import { render, staticRenderFns } from "./AssistantTab.vue?vue&type=template&id=5b63ee9c&scoped=true&"
import script from "./AssistantTab.vue?vue&type=script&lang=js&"
export * from "./AssistantTab.vue?vue&type=script&lang=js&"
import style0 from "./AssistantTab.vue?vue&type=style&index=0&id=5b63ee9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63ee9c",
  null
  
)

export default component.exports